const lists = {
  data() {
    return {
      lists: [],
      years: [],
      all_lists: [],
      isDisplay: true,
      is_ja: $("html").attr("lang") === "ja",
    };
  },
  created() {
    this.getLists();
  },
  mounted() {
    window.addEventListener("wovnApiReady", this.getLang);
  },
  methods: {
    getLang() {
      if (window.WOVN && WOVN.io.getWovnUrl() !== undefined) {
        this.is_ja = WOVN.io.getCurrentLang().code === "ja";
      } else {
        this.is_ja = $("html").attr("lang") === "ja";
      }
      this.getLists();
    },
    getLists: async function () {
      const data = await axios
        .get("/ir/news/data/latest_news.json")
        .then((response) => response.data);

      if (typeof data === "object") {
        if (this.is_ja) {
          this.all_lists = data.filter((list) => list.lang === "jp");
        } else {
          this.all_lists = data.filter((list) => list.lang === "en");
        }
      } else {
        this.isDisplay = false;
      }
      this.getYears(this.all_lists);
      this.setLists(this.all_lists);
    },
    getYears: function (data) {
      const years = [
        ...new Set(
          data.map(function (a) {
            return parseInt(a.published.slice(0, 4));
          })
        ),
      ].sort((a, b) => b - a);
      this.years = years;
    },
    setLists: function (data, year) {
      const jp_news = data.sort(
        (a, b) => parseInt(b.published) - parseInt(a.published)
      );

      let news_list = [];
      let count = -1;
      const maxNewsCount = 3;
      $.each(jp_news, function (index, value) {
        const date = value.published;
        const year = date.substr(0, 4);
        const month = date.substr(4, 2);
        const day = date.substr(6, 2);
        if (count + 1 < maxNewsCount) {
          news_list.push([
            {
              category: value.category,
              date: year + "/" + month + "/" + day,
              is_pdf: value.pdf_icon,
              link: value.link,
              target: value.target,
              title: value.title,
            },
          ]);
        } else {
          return false;
        }
        count++;
      });
      this.lists = news_list;
    },
  },
};
Vue.createApp(lists).mount("#news-list");

const banner = {
  data() {
    return {
      banners: [],
      all_banners: [],
      isDisplay: true,
      is_ja: $("html").attr("lang") === "ja",
    };
  },
  created() {
    this.getLists();
  },
  mounted() {
    window.addEventListener("wovnApiReady", this.getLang);
  },
  methods: {
    getLang() {
      if (window.WOVN && WOVN.io.getWovnUrl() !== undefined) {
        this.is_ja = WOVN.io.getCurrentLang().code === "ja";
      } else {
        this.is_ja = $("html").attr("lang") === "ja";
      }
      this.getLists();
    },
    getLists: async function () {
      const data = await axios
        .get("/ir/data/top_feature.json")
        .then((response) => response.data);

      if (typeof data === "object") {
        if (this.is_ja) {
          this.all_banners = data.filter((banner) => banner.lang === "jp");
        } else {
          this.all_banners = data.filter((banner) => banner.lang === "en");
        }
      } else {
        this.isDisplay = false;
      }
      this.setLists(this.all_banners);
    },
    setLists: function (data) {
      let banner_list = [];
      $.each(data, function (index, value) {
        banner_list.push({
          alt: value.alt,
          thumbnail_pc: value.thumbnail_pc,
          thumbnail_sp: value.thumbnail_sp,
          link: value.link,
        });
      });
      this.banners = banner_list;
    },
  },
};
Vue.createApp(banner).mount("#banner");

const document_list = {
  data() {
    return {
      documents: [],
      years: [],
      all_lists: [],
      isDisplay: true,
      download_all: [],
      is_ja: $("html").attr("lang") === "ja",
    };
  },
  created() {
    this.getLists();
  },
  mounted() {
    const self = this;
    window.addEventListener("wovnApiReady", function () {
      setTimeout(function () {
        self.getLang();
      }, 0);
    });
  },
  methods: {
    getLang() {
      if (window.WOVN && WOVN.io.getWovnUrl() !== undefined) {
        this.is_ja = WOVN.io.getCurrentLang().code === "ja";
      } else {
        this.is_ja = $("html").attr("lang") === "ja";
      }
      this.getLists();
    },
    getLists: async function () {
      const data = await axios
        .get("/ir/library/data/latest_file.json")
        .then((response) => response.data);

      if (typeof data === "object") {
        if (this.is_ja) {
          this.all_lists = data.filter((list) => list.lang === "jp");
        } else {
          this.all_lists = data.filter((list) => list.lang === "en");
        }
      } else {
        this.isDisplay = false;
      }
      this.setLists(this.all_lists);
    },
    setLists: function (data) {
      let all_document = [];
      let download_all = [];
      let rest_list = [];
      let count = -1;
      const maxShowCount = 7;
      $.each(data, function (index, value) {
        const date = value.published;
        let sizeFormatted = null;
        if (value.size !== null) {
          sizeFormatted = value.size.toLocaleString();
        }
        if (count + 1 < maxShowCount) {
          all_document.push({
            title: value.title,
            link: value.link,
            size: sizeFormatted,
          });
        } else {
          return false;
        }
        count++;
      });

      [download_all, ...rest_list] = all_document;
      this.documents = rest_list;
      this.download_all = download_all;
    },
  },
};
Vue.createApp(document_list).mount("#document");
